import 'core-js/modules/es.array.concat.js';
import 'core-js/modules/es.object.assign.js';
import { __rest } from 'tslib';
import { jsx, jsxs } from 'react/jsx-runtime';
import React from 'react';
import classNames from 'classnames';
import { useIsOverflowing, getThemeClassNames, IconWrapper } from '@cognite/cogs-utils';
import { useConfigContextLoose } from '../config-provider/config-provider.js';
import { Tooltip } from '../tooltip/tooltip.js';
import { getIcon } from './utils.js';

/**
 * Status chips communicate severity level information to users and are dynamic by nature.
 * They can be used to communicate the status of a system, a device, or a process.
 */
var StatusChip = /*#__PURE__*/React.forwardRef(function (_a, outerRef) {
  var className = _a.className,
    label = _a.label,
    hideIcon = _a.hideIcon,
    inverted = _a.inverted,
    _a$size = _a.size,
    size = _a$size === undefined ? 'medium' : _a$size,
    _a$variant = _a.variant,
    variant = _a$variant === undefined ? 'ghost' : _a$variant,
    icon = _a.icon,
    _a$status = _a.status,
    status = _a$status === undefined ? 'undefined' : _a$status,
    themeProps = _a.themeProps,
    tooltipProps = _a.tooltipProps,
    _a$tooltip = _a.tooltip,
    tooltip = _a$tooltip === undefined ? true : _a$tooltip,
    otherProps = __rest(_a, ["className", "label", "hideIcon", "inverted", "size", "variant", "icon", "status", "themeProps", "tooltipProps", "tooltip"]);
  var iconSizeMap = {
    'x-small': 12,
    small: 14,
    medium: 16
  };
  var iconSize = variant === 'ghost' ? iconSizeMap.medium : iconSizeMap[size];
  var ChipIcon = getIcon(status, variant === 'outline');
  var innerRef = React.useRef(null);
  var ref = innerRef;
  var isOverflowing = useIsOverflowing(ref, label);
  var showTooltip = tooltip === true && isOverflowing || typeof tooltip === 'string';
  var _useConfigContextLoos = useConfigContextLoose(),
    getOverlayContainer = _useConfigContextLoos.getOverlayContainer;
  return jsx(Tooltip, Object.assign({
    content: typeof tooltip === 'string' ? tooltip : label,
    disabled: !showTooltip,
    appendTo: getOverlayContainer === null || getOverlayContainer === undefined ? undefined : getOverlayContainer()
  }, tooltipProps, {
    children: jsxs("div", Object.assign({
      "data-testid": label,
      ref: outerRef,
      className: classNames.apply(undefined, ['cogs-v10', 'cogs-statuschip', "cogs-statuschip--" + variant].concat(getThemeClassNames(inverted, themeProps), ["cogs-statuschip--" + status, variant === 'outline' && "cogs-statuschip--" + size, className]))
    }, otherProps, {
      children: [!hideIcon && jsx(IconWrapper, {
        className: "cogs-v10 cogs-statuschip__icon",
        size: iconSize,
        children: icon ? icon : jsx(ChipIcon, {})
      }), jsx("div", {
        ref: ref,
        className: classNames('cogs-v10', variant === 'outline' ? "cogs-body-" + size : 'cogs-body-medium', 'cogs-statuschip--text', hideIcon && 'cogs-statuschip--text--no-icon', {
          strong: variant === 'outline'
        }),
        children: label
      })]
    }))
  }));
});

export { StatusChip };
